export default __webpack_public_path__ + "static/media/IT.967b0f4e.png";